import {SET_USER_DATA, USER_INFO_REQUEST} from 'constants/index';

export const setUserData = (payload) => ({
    type: SET_USER_DATA, payload
})

export const getUserInfo = (payload) => ({
    type: USER_INFO_REQUEST, payload
})